"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueVisitPlanDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
/** Personal plan to visit a venue (distinct from community event RSVP). */
class VenueVisitPlanDto {}
exports.VenueVisitPlanDto = VenueVisitPlanDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueVisitPlanDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueVisitPlanDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueVisitPlanDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], VenueVisitPlanDto.prototype, "venueLogoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueVisitPlanTimeSlot
}), __metadata("design:type", String)], VenueVisitPlanDto.prototype, "timeSlot", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  example: '2026-05-21'
}), __metadata("design:type", String)], VenueVisitPlanDto.prototype, "plannedDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether this plan’s time window is currently active.'
}), __metadata("design:type", Boolean)], VenueVisitPlanDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether this plan’s time window has ended.'
}), __metadata("design:type", Boolean)], VenueVisitPlanDto.prototype, "isPassed", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueVisitPlanDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Whether this plan has already been synced to the owning user's Google Calendar."
}), __metadata("design:type", Boolean)], VenueVisitPlanDto.prototype, "googleCalendarSynced", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], VenueVisitPlanDto.prototype, "autoCheckInPublicId", void 0);
//# sourceMappingURL=VenueVisitPlan.dto.js.map